import { isLocale, locale, LOCALES, requestLocale, t } from "./index.ts";

/** Compact language picker for page bars: each language listed in its own name. */
export function languageSelect(className = "lang-select"): HTMLSelectElement {
  const select = document.createElement("select");
  select.className = className;
  select.setAttribute("aria-label", t("lang.label"));
  select.title = t("lang.label");
  for (const l of LOCALES) {
    const option = document.createElement("option");
    option.value = l.code;
    option.textContent = l.name;
    option.lang = l.code;
    option.selected = l.code === locale();
    select.append(option);
  }
  select.addEventListener("change", () => {
    const next = select.value;
    if (!isLocale(next)) return;
    select.value = locale();
    requestLocale(next);
  });
  return select;
}

/** Radio items for a ☰ menu: a small "Language" label, then one row per language. */
export function fillLanguageMenu(container: HTMLElement, onPick: () => void): void {
  container.replaceChildren();
  const label = document.createElement("span");
  label.className = "panel-menu-label";
  label.textContent = t("lang.label");
  container.append(label);
  for (const l of LOCALES) {
    const item = document.createElement("button");
    item.type = "button";
    item.setAttribute("role", "menuitemradio");
    item.setAttribute("aria-checked", String(l.code === locale()));
    item.className = "panel-menu-lang";
    item.lang = l.code;
    item.dataset.lang = l.code;
    item.textContent = l.name;
    item.addEventListener("click", () => {
      onPick();
      requestLocale(l.code);
    });
    container.append(item);
  }
}

/** Message-only quest screens (sign in, not found) get the picker under their text. */
export function appendLanguageSwitch(root: ParentNode): void {
  const shell = root.querySelector(".quest-shell");
  if (!shell || shell.querySelector(".lang-select")) return;
  const select = languageSelect("lang-select quest-msg-lang");
  const actions = shell.querySelector(".route-window-msg-actions");
  if (actions) actions.append(select);
  else shell.append(select);
}
